import styled from 'styled-components';
import {getSpacing} from '@tickchak/react-share/app';
import {mobileMedia} from '../../../../globalVariables/GlobalVariables';

export const quillWrap = styled.div<{direction: 'ltr' | 'rtl'}> `
    direction: ${p => p.direction};
    -webkit-text-size-adjust: 100%;
    .ql-container.ql-snow {
        border: none;
        font-size: inherit;
    }

    .ql-editor {
        text-align:  ${p => p.direction==='ltr' ? 'left' : 'right'};
        min-height: 200px;
        outline: none;
        padding: ${getSpacing('spaceSm')} var(--space-2xl);
        direction: ${p => p.theme.direction};
        margin: 0;
        .variable {
            font-weight: var(--font-weight-bold);
            color: var(--primitive-turquoise-700);
        }
        .variable[data-italic='true'] {
            font-style: italic;
        }
        ${mobileMedia} {
            font-size: 16px;
        }
    }
`;
